<template>
	<div class="all">
		<form @submit.prevent="submit">
			<div class="row">
				<div class="col-md-12">
					<h4>{{ _traducao('global', 'alterarSenha').toUpperCase() }}</h4>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 0px" />

			<div class="row">
				<div class="col-xs-12">
					<div class="row" style="margin-top: 16px; margin-bottom: 16px">
						<div class="col-md-4 col-xs-12 text-center">
							<div v-show="foto != ''">
								<img :src="foto" class="foto-troca" />
							</div>

							<div v-show="foto == ''">
								<p :data-letters="nomeReduzido"></p>
								<!-- <div class="div-nome" style="height: 124px;">
                                <p class="div-texto" style="padding-top: 32px;">{{nomeReduzido}}</p>
                            </div> -->
							</div>
						</div>
						<div class="col-md-8 col-xs-12">
							<h3 style="margin-top: 0px">{{ nome }}, {{ _traducao('global', 'porQuestoesAlterarSenha') }}</h3>

							<h3>
								{{ _traducao('global', 'digiteNovaSenhaAbaixo') }}
							</h3>

							<!-- <div class="form-group">
                            <label>Login: </label>
                            <input v-model="login" type="text" disabled="disabled" class="form-control input-sm" />
                        </div> -->
							<div class="form-group" :class="{'has-error': erroSenha != ''}">
								<label>{{ _traducao('global', 'novaSenha') }}: </label>
								<div
									class="fa fa-eye icone-senha"
									title="Clique para ver a senha"
									@mousedown="inputSenha = true"
									@mouseup="inputSenha = false"
									aria-hidden="true"
								></div>
								<input v-show="inputSenha" type="text" v-model="senha" class="form-control input-sm" />
								<input v-show="!inputSenha" type="password" v-model="senha" class="form-control input-sm" />
								<!--<input v-model="senha" type="password" class="form-control input-sm" /> -->
								<p class="help-block" v-show="erroSenha != ''">{{ erroSenha }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 10px" />

			<div class="row">
				<div class="col-xs-12">
					<button class="btn btn-success pull-right">
						{{ _traducao('global', 'alterarSenha').toUpperCase() }}
						<i class="fa fa-fw fa-check"></i>
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
var jwt_token = require('jwt-decode')

export default {
	props: ['name'],

	data: function () {
		return {
			login: '',
			senha: '',
			erroSenha: '',
			token: '',

			inputSenha: false,

			nomeReduzido: '',
			nome: '',
			foto: ''
		}
	},

	methods: {
		carregaTrocarSenha(obj) {
			var dados = jwt_token(obj.token)
			this.token = obj.token
			this.nome = dados.nome.split(' ')[0]
			this.login = dados.login
			var nome = dados.nome.split(' ')

			//console.log(dados)

			if (nome.length > 1) {
				this.nomeReduzido = nome[0].substring(0, 1) + nome[1].substring(0, 1)
			} else {
				this.nomeReduzido = nome[0].substring(0, 2)
			}

			if (!_.isNil(dados.foto)) {
				if (dados.foto != '') {
					this.foto = this.getURL_WS('/foto/').replace('public/', '') + dados.foto
				}
			}
		},

		submit: function () {
			this.senha += ''
			if (this.senha.trim() == '') {
				this.erroSenha = this._traducao('global', 'voceNovaSenha')
				return false
			} else {
				this.erroSenha = ''
			}

			bus.$emit('load-in', {text: this._traducao('global', 'alterandoSenha')})

			var data = {
				login: this.login,
				senha: this.senha
			}

			jQuery.ajax({
				type: 'POST',
				headers: {Authorization: this.token},
				url: this.getURL_WS('/Usuario/alterar_senha'),
				data: {data: JSON.stringify(data)},
				dataType: 'json',
				success: (retorno) => {
					////console.log(retorno)

					bus.$emit('load-out')

					this.exibirLoad = false

					// deu certo, Login ok!
					if (retorno.status == 'sucesso') {
						this.$emit('alterou-senha', data.senha)
					} else {
						bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('global', 'naoFoiPossivelAlterarSenha')})
					}
				},
				error: function (e) {
					//console.log(e);
					//console.log("aii");
					bus.$emit('modal-erro-show', e)
				}
			})
		}
	}
}
</script>